import {
  Box,
  Grid,
  ImageList,
  ImageListItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect } from "react";
import { BRANDS } from "../types/types";
import { useNavigate } from "react-router-dom";

interface BrandListProps {}

const BrandList: React.FC<BrandListProps> = (props) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg")); // sm >= 640px
  const isTablet = useMediaQuery(theme.breakpoints.up("md")); // md >= 900px
  const brands = BRANDS;
  let colsToDisplay = 12;

  if (isDesktop) {
    colsToDisplay = 12;
  } else if (isTablet) {
    colsToDisplay = 6;
  } else {
    colsToDisplay = 4;
  }
  useEffect(() => {}, []);
  return (
    <section className="bg-white">
      <Box className="w-full">
        <ImageList
          variant="woven"
          cols={colsToDisplay}
          rowHeight={64}
          className="!p-3 md:!p-5"
        >
          {brands.map((item) => (
            <ImageListItem key={item.logo}>
              <img
                srcSet={`${item.logo}`}
                src={`${item.logo}`}
                alt={item.name}
                loading="lazy"
                className="!object-contain !px-3 md:!px-5"
                onClick={() => {
                  navigate(`/products/?brand=${item.id}`);
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
    </section>
  );
};

export default BrandList;
